module.exports = __webpack_public_path__ + "img/13.5d384144.png";